import React from 'react';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import { appName } from '../../../../config/uri';

import Televida from '~/assets/images/Televida-logo.svg';

import useStyles from './styles';

function Logo({ open, setOpen }) {
  const classes = useStyles();

  return (
    <ListItem
      classes={{
        root: classes.root,
      }}
      onClick={() => setOpen(!open)}
    >
      <ListItemIcon>
        <img src={Televida} className={classes.image} />
      </ListItemIcon>

      {/* <ListItemText primary={appName} classes={{ primary: classes.text }} /> */}

      <ChevronLeftIcon style={{ color: '#ffffff', marginLeft: '15px' }} />
    </ListItem>
  );
}

export default React.memo(Logo);
